import connectGeoSearch from "instantsearch.js/es/connectors/geo-search/connectGeoSearch.js";
import { useConnector } from "../hooks/useConnector.js";
export function useGeoSearch(props, additionalWidgetProperties) {
  return useConnector(connectGeoSearch, props, additionalWidgetProperties);
}